import {validatePhoneNumber} from "../services/contact-validation";
import utils from "../utils/utils";

export function validatePhone(phone) {
    return validatePhoneNumber(phone, utils.get_locale());
}

export function validateEmail($email) {
    let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test($email);
}

export function getPartnerID() {
    const urlParams = new URLSearchParams(window.location.search);
    const get = Object.fromEntries(urlParams.entries());
    return get.ng_pid ? get.ng_pid : null;
}


$.fn.replaceOptions = function (options) {
    let self, $option;

    this.empty();
    self = this;

    $.each(options, function (index, option) {
        $option = $("<option></option>")
            .attr("value", option.value)
            .attr("name", option.name)
            .text(option.text);
        self.append($option);
    });
};

export function isTemplate(template) {
    return $('.page-template-' + template).length
}